import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckRectangularL18 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 101,
	height: 101,
	viewBox: "0 0 101 101",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_7847_246255)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M84.9521 8.69531H16.9521C12.5338 8.69531 8.95206 12.277 8.95206 16.6953V84.6953C8.95206 89.1136 12.5338 92.6953 16.9521 92.6953H84.9521C89.3703 92.6953 92.9521 89.1136 92.9521 84.6953V16.6953C92.9521 12.277 89.3703 8.69531 84.9521 8.69531Z",
				fill: "#F8F9FA"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.3269 67.9708L35.9119 55.1268L38.571 52.3928L48.7849 62.1238L69.054 33.4238L72.1672 35.6238L49.3269 67.9708Z",
			fill: "#1F65F0",
			stroke: "#1F65F0"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_7847_246255",
			x: 6.95206,
			y: 7.69531,
			width: 88,
			height: 88,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_7847_246255"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_7847_246255",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgCheckRectangularL18;
